/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class entity extends IceEntity {
    entity_key: string = "";
    entity_identifier_code: string = "";
    entity_type_qualifier: IceTypes.entity_type_qualifier = IceTypes.entity_type_qualifier.etqPerson;
    organization_name: string = "";
    first_name: string = "";
    last_name: string = "";
    initial: string = "";
    prefix: string = "";
    suffix: string = "";
    additional_name: string = "";
    sex: string = "";
    marital_status: IceTypes.maritalstatus = IceTypes.maritalstatus.msNone;
    dob: any = NaN;
    dod: any = NaN;
    ssn_fedid_num: string = "";
    state_license_num: string = "";
    lcid: number = 0;
    record_version: number = 0;
    offline_record_status: number = 0;
    accessed: any = NaN;
    accessed_user: string = "";
    created: any = NaN;
    created_user: string = "";
    modified: any = NaN;
    modified_user: string = "";

    constructor() {
        super();
    }

    gettablename() {
        return "ENTITY";
    }

    getdisplayname(organization: boolean): string {
        if (organization)
            return this.organization_name;

        var disply = this.prefix;
        if (disply.length > 0)
            disply += " ";

        disply += this.first_name;

        if (this.initial != null && this.initial.length > 0)
            disply += ", " + this.initial;

        if (disply.length > 0)
            disply += " " + this.last_name;

        if (this.suffix.length > 0)
            disply += ", " + this.suffix;

        return disply;
    }

    hassubtree(ColumnName: string): boolean {
        if (ColumnName.length == 0) return false;
        else if (ColumnName == "LANGS") return true;

        return false;
    }

    getsubtreetablename(ColumnName: string): any {
        if (ColumnName.length == 0) return null;
        else if (ColumnName == "LANGS") return "LANGUAGE";

        return null;
    }
}
